import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarCollapsed: false,
    language: localStorage.getItem('lang') || 'en',
  },
  reducers: {
    toggleSidebar(state) { state.sidebarCollapsed = !state.sidebarCollapsed; },
    setLanguage(state, action) {
      state.language = action.payload;
      localStorage.setItem('lang', action.payload);
    },
  },
});

export const { toggleSidebar, setLanguage } = uiSlice.actions;
export default uiSlice.reducer;
